import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFleetState, IPositionVehicle, ITagVehicle, IVehicle } from "@types";

const initialState: IFleetState = {
  allVehicles: [],
  groupsVehicle: [],
  vehiclesFiltered: [],
  groupsFiltered: [],
  openDetail: false,
  position: {},
  vehicle: {
    id: "",
    name: "",
    brand: "",
  },
  totalByVehicleType: {
    truck: 0,
    bus: 0,
    trailer: 0,
    van: 0,
  },
  openVehicles: true,
};

export const FleetSlice = createSlice({
  name: "Fleets",
  initialState,
  reducers: {
    setListAllVehicles: (state, action: PayloadAction<IVehicle[]>) => {
      state.allVehicles = action.payload;
    },
    setListAllGroups: (state, action: PayloadAction<ITagVehicle[]>) => {
      state.groupsVehicle = action.payload;
    },
    setGroupsFilter: (state, action: PayloadAction<string[]>) => {
      state.groupsFiltered = action.payload;
    },
    setVehiclesFilter: (state, action: PayloadAction<string[]>) => {
      state.vehiclesFiltered = action.payload;
    },
    defaultFleet: (state) => {
      state = initialState;
    },
    setOpenSidebarDetail: (state, action: PayloadAction<boolean>) => {
      state.openDetail = action.payload;
    },
    setOpenVehicles: (state, action: PayloadAction<boolean>) => {
      state.openDetail = action.payload;
    },
    setVehicleSelected: (state, action: PayloadAction<IVehicle>) => {
      state.vehicle = action.payload;
    },
    setVehiclePosition: (state, action: PayloadAction<IPositionVehicle>) => {
      state.position = action.payload;
    },
    setTotalByVehicleType: (state, action: PayloadAction<{ truck: number; bus: number; trailer: number; van: number }>) => {
      state.totalByVehicleType = action.payload;
    },
  },
});

export const {
  defaultFleet,
  setListAllVehicles,
  setListAllGroups,
  setGroupsFilter,
  setVehiclesFilter,
  setOpenSidebarDetail,
  setVehiclePosition,
  setVehicleSelected,
  setTotalByVehicleType,
  setOpenVehicles,
} = FleetSlice.actions;

export default FleetSlice.reducer;

